module.exports = __webpack_public_path__ + "static/media/move.7a804d5e.svg";